<div class="row align-items-center">
  <div class="col-sm-1">
    {{'global.status'|translate}} <span class="star" *ngIf="statusRequired">*</span>
  </div>
  <div class="col-sm-7">
    <ng-select
      #statusSelect="ngModel"
      [name]="'change_status_status'+Index"
      [items]="statuses"
      [(ngModel)]="solution.solutionSteps[Index].actionChangeStatus.status"
      (ngModelChange)="updateSolution()"
      bindValue="id"
      [clearable]="false"
      [required]="statusRequired">
      <ng-template ng-label-tmp let-item="item">
        {{item.translationKey|translate}}
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        {{item.translationKey|translate}}
      </ng-template>
    </ng-select>
  </div>
</div>
